<div class="footer-wrap">
    <div class="platform_footer">
        <footer *ngIf="footerItems" class={{footerClass}} role="contentinfo">
            <div class={{footerLeftDivClass}}>
                <span class={{copyrightClass}}>{{footerItems.copyRightText}}</span>
                <div class="footer-links-parent-wrapper">
                    <ul class={{listClass}} role="menu">
                        <li role="presentation">
                            <a
                                target="_blank"
                                role="menuitem" 
                                rel="noopener noreferrer"
                                class={{firstFooterLinkClass}}
                                href={{footerItems.userAgreement.url}}
                                aria-label={{footerItems.userAgreement.label}}
                                >{{footerItems.userAgreement.label}}</a>
                        </li>
                        <li role="presentation">
                            <a 
                                target="_blank" 
                                role="menuitem" 
                                rel="noopener noreferrer"
                                class={{footerLinkClass}}
                                href={{footerItems.privacyPolicy.url}}
                                aria-label={{footerItems.privacyPolicy.label}}
                                >{{footerItems.privacyPolicy.label}}
                            </a>
                        </li>
                        <li role="presentation">
                            <a
                                target="_blank"
                                role="menuitem"
                                rel="noopener noreferrer"
                                class={{lastFooterLinkClass}}
                                href={{footerItems.credits.url}}
                                aria-label="Credits opens in a new tab"
                            >Credits</a>
                        </li>
                    </ul>
                    <span class="tag">{{footerItems.revisionTag}}</span>
                </div>
            </div>
            <div class={{footerRightDivClass}}>
                <img src={{logoSrc}} alt="Savvas Logo" />
            </div>
        </footer>
    </div>
</div>
